


























import { Prop, Component, Vue } from "vue-property-decorator";
import Icon from "@/models/icon";
import { getIcons } from "@/api/icon-api";

@Component({})
export default class SelectIcon extends Vue {
  @Prop({ default: 0 }) id!: number;

  currentId = 0;
  icons: Icon[] = [];

  async created() {
    this.icons = await getIcons();
  }

  async ok() {
    if (this.id === this.currentId) return;
    await this.$store.dispatch("saveIcon", this.currentId);
  }

  change(icon: Icon) {
    this.currentId = icon.id;
  }

  reset() {
    this.currentId = this.id;
  }

  selected(icon: Icon) {
    return this.currentId === icon.id ? "active" : "";
  }
}
